export { Footer, Container, LoadingContainer, Header, Main } from './styled';
export { Loader } from './Loader';
